<template>
    <!-- START: section-content -->
    <section class="section section-content section-tariff-content bg-grey">

        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="module headline">
                       <slot name="title" />
                    </div>

                    <div class="module content">
                        <slot />
                    </div>
                </div>
                <div class="col-lg-4"></div>
            </div>
        </div>

    </section>
    <!-- END: section-content -->
</template>
<script>
export default {
    name: 'BestellstreckeHeader'
}
</script>
